import React from "react";

interface RightArrowProps {
  color?: string;
}

const RightArrow: React.FC<RightArrowProps> = ({ color }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m6.674 12 4-4-4-4"
        stroke={color || "#FCFCFD"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RightArrow;
